import useCallApi from '../../utilities/axios'

import type { FileInfo } from './types/responseWebServiceTypes'

const baseUrl = `${process.env.REACT_APP_CU_IRB_API_URL}`

export type SenderRole = 'officer' | 'researcher'

export interface MessengerQuery {
    senderRole: SenderRole
}
export interface Messenger {
    senderRole: SenderRole
    messageText: string
    readAt: string | null
    createdDate: string
    documentInfo: { fileInfo: FileInfo[] }[] | null
}

export interface MessengerRequest {
    senderRole: SenderRole
    messageText: string
    documentInfo: { fileTokenInfo: string[] }[] | null
}

export interface MessengerUnreadCount {
    projectID: number
    unreadCount: number
}

const useMessenger = () => {
    const callApi = useCallApi()

    async function getMessengers(projectId: number, params: MessengerQuery) {
        const { data } = await callApi.axiosGet<{
            message: string
            status: number
            result: Messenger[]
        }>({
            url: `${baseUrl}/project/${projectId}/messenger`,
            config: { params },
        })

        return data
    }

    async function createMessenger(projectId: number, params: MessengerRequest) {
        const { data } = await callApi.axiosPost<{
            message: string
            status: number
            result: Messenger
        }>({
            url: `${baseUrl}/project/${projectId}/messenger`,
            params,
        })

        return data
    }

    async function getMessengersUnreadCount(projectId: number, params: MessengerQuery) {
        const { data } = await callApi.axiosGet<{
            message: string
            status: number
            result: MessengerUnreadCount
        }>({
            url: `${baseUrl}/project/${projectId}/messenger/unread-count`,
            config: { params },
        })

        return data
    }

    return {
        getMessengers,
        createMessenger,
        getMessengersUnreadCount,
    }
}

export default useMessenger
